import type { IconProps } from './IconProps';

export const InfoCircleSolidSmallIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_15_1037)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00004 13.9166C4.73236 13.9166 2.08337 11.2676 2.08337 7.99996C2.08337 4.73227 4.73236 2.08329 8.00004 2.08329C11.2677 2.08329 13.9167 4.73227 13.9167 7.99996C13.9167 11.2676 11.2677 13.9166 8.00004 13.9166ZM0.583374 7.99996C0.583374 12.0961 3.90393 15.4166 8.00004 15.4166C12.0962 15.4166 15.4167 12.0961 15.4167 7.99996C15.4167 3.90385 12.0962 0.583292 8.00004 0.583292C3.90393 0.583292 0.583374 3.90385 0.583374 7.99996ZM8.00004 11.4166C8.41425 11.4166 8.75004 11.0808 8.75004 10.6666V7.99996C8.75004 7.58575 8.41425 7.24996 8.00004 7.24996C7.58583 7.24996 7.25004 7.58575 7.25004 7.99996V10.6666C7.25004 11.0808 7.58583 11.4166 8.00004 11.4166ZM7.25004 5.33329C7.25004 5.74751 7.58583 6.08329 8.00004 6.08329H8.00671C8.42092 6.08329 8.75671 5.74751 8.75671 5.33329C8.75671 4.91908 8.42092 4.58329 8.00671 4.58329H8.00004C7.58583 4.58329 7.25004 4.91908 7.25004 5.33329Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_1037">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
